import { Action } from 'redux';
import { PetBreakdownReport } from 'model/ClientAndPetsReport';

// Action Types
export const PET_BREAKDOWN_REPORT_GET_START = 'PET_BREAKDOWN_REPORT_GET_START';
export const PET_BREAKDOWN_REPORT_GET_SUCCESS = 'PET_BREAKDOWN_REPORT_GET_SUCCESS';
export const PET_BREAKDOWN_REPORT_GET_ERROR = 'PET_BREAKDOWN_REPORT_GET_ERROR';

// Actions

type PetBreakdownReportGetStartAction = Action<typeof PET_BREAKDOWN_REPORT_GET_START>;

interface PetBreakdownReportGetSuccessAction extends Action<typeof PET_BREAKDOWN_REPORT_GET_SUCCESS> {
    payload: {
        report: PetBreakdownReport;
    };
}

type PetBreakdownReportErrorAction = Action<typeof PET_BREAKDOWN_REPORT_GET_ERROR>;

export type PetBreakdownReportAction =
    | PetBreakdownReportGetStartAction
    | PetBreakdownReportGetSuccessAction
    | PetBreakdownReportErrorAction;
